import React, { useState, useEffect, useRef } from 'react';
import {
  IconButton,
  IconVideoCameraLine,
} from '@smarterservices/smarter-ui';
import { getStore } from '../../../../stores/StoreContext';
const ViewAnnotationButton = ({
  annotation,
}) => {

  const ExamSessionStore = getStore('examSessionStore');

  // until the quick viewer is implemented, this will not output anything
  return null;

  return (
    <IconButton
      size="small"
      color="secondary"
      margin="none x-small none none"
      screenReaderLabel="Delete Annotation"
      onClick={() => ExamSessionStore.setManagingAnnotation(annotation)}
    >
      <IconVideoCameraLine />
    </IconButton>
  );
};

export default ViewAnnotationButton;
